export default __webpack_public_path__ + "static/media/12.43625fc5.jpg";